<template>
    <div
        translate="no"
        class="app"
        v-bind:class="[isMobile ? 'mobile' : 'desktop']"
    >
        <div class="section-studio">
            <NftItemDemi />
        </div>
        <IconsNft />
    </div>
</template>

<script setup lang="ts">
    import IconsNft from '@/components/Icon/IconsNft.vue';
    import NftItemDemi from '@/components/NftItemDemi.vue';
    import { GlobalStore } from '@/store/GlobalStore';

    const { isMobile } = GlobalStore;
</script>

<style lang="scss">
    @import "~@/scss/reset.scss";
    @import '~@/scss/global-animation.scss';
    @import "@/scss/global.scss";
    @import '@/scss/global-rwd.scss';

    html, body, .app {
        overflow: hidden;
        padding: 0;
        margin: 0;
        .rectext,
        h1,
        h2,
        h3,
        h4,
        h5,
        h6 {
            // font-family: "BlackOpsOne", Roboto, "Browallia New", sans-serif;
        }

    }
    .app {
        .section-studio {
            overflow: hidden;
            width: 100vw;
            height: 100vh;
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
</style>
